const ENGINE_BASE = (process.env.REACT_APP_CHIC_ENGINE_ENDPOINT || '').replace(/\/+$/, '');
const PUBLIC_BASE = `${ENGINE_BASE}/api/v1/consents`;

const jsonFetch = async (path, opts = {}) => {
  const res = await fetch(`${PUBLIC_BASE}${path}`, {
    redirect: 'manual',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...(opts.headers || {}),
    },
    ...opts,
  });

  const text = await res.text();
  if (!res.ok) {
    let message = text || `${res.status} ${res.statusText}`;
    try {
      const err = text ? JSON.parse(text) : null;
      message = err?.detail || err?.message || message;
    } catch {
      // ignore parse errors
    }
    throw new Error(message);
  }

  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch {
    throw new Error(`Expected JSON, received: ${text.slice(0, 120)}`);
  }
};

export async function fetchSignupConsentOptions() {
  return jsonFetch('/signup-options');
}

export async function logSignupConsents(payload) {
  return jsonFetch('/log', {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
      'Content-Type': 'application/json',
    },
  });
}
